import React from "react";
import Navbar from "../components/Navbar";
import "../styles/global.css";
import Category from "../components/Category";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router";

const CategoryPage = () => {
  const { category } = useParams();
  const timeAttendanceSortDesc =
    "Explore advanced biometric time attendance and access control systems with face recognition, fingerprint scanning, and Wi-Fi support for secure employee management in offices, schools, factories, and more.";
  const defaultSortDesc =
    "Browse a wide range of security solutions at TimeWatch Infocom, your trusted provider for advanced biometric systems, access control solutions, and smart security technologies in Delhi. Discover top categories, including entrance automation, time attendance systems, parking management solutions, and surveillance technologies. Our cutting-edge products are designed for businesses, organizations, and industries seeking innovative security solutions that ensure efficiency and safety. Explore the best in security technology tailored to your needs.";

  const timeAttendanceKeywords = [
    "biometric attendance system",
    "time attendance machine",
    "fingerprint attendance machine",
    "face recognition attendance",
    "access control system",
    "employee attendance device",
    "biometric access control",
    "office attendance solution",
    "attendance and access control",
    "face and fingerprint attendance machine",
    "staff attendance system",
    "biometric door access",
    "wifi attendance machine",
    "secure access control device",
    "digital attendance system",
  ];
  return (
    <>
      <Helmet>
        {console.log("category", category)}
        <title>
          {`${category
            .split("-") // Split by hyphen
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
            .join(" ")}`}{" "}
          | TimeWatch Infocom
        </title>
        <meta
          name="description"
          content={`${
            category === "time-attendance-and-access-control"
              ? " Time Attendance and Access Control, " + timeAttendanceSortDesc
              : defaultSortDesc
          }`}
        />
        <meta
          name="keywords"
          content={`${
            category === "time-attendance-and-access-control" ? timeAttendanceKeywords : ""
          }`}
        />

        <link
          rel="canonical"
          s
          href={`https://www.timewatchindia.com/market-place/${category} `}
        />
      </Helmet>
      <header className="navbar">
        <Navbar />
      </header>

      <div className="content-container">
        <section className="category">
          <Category />
        </section>
      </div>

      <footer className="footer">
        <Footer />
      </footer>
    </>
  );
};

export default CategoryPage;
